
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const common = {
    namespaced: true,
    state: {
        loginStatus: null,
        opcity: 0
    },
    getters : {
        loginStatus:state => state.loginStatus,
        isOpcity: state => state.isOpcity
    },
    mutations: {
        SET_COMMON_VALUE: (state, v) => {
            state[v.key] = v.value;
        },
        SET_FACTORY_CODE: (state, v) => {
            state.factoryCode = v;
        },
        SET_LOGIN: (state, v) => {
            state.loginStatus = v
        },
        SET_OPCITY: (state, v) => {
            console.log('v', v)
            if(v == '/home' || v=='/programme' || v== '/partner'){
                state.opcity = 0.3
            }else if(v == '/contact'){
                state.opcity = 0.8
            }else {
                state.opcity = 1
            }
            console.log(state.opcity)
            // state.isOpcity = v
        }
    },
    actions: {
        updateLogin({commit}, status) {
            commit('SET_LOGIN', status)
        },
        updateOpcity({commit}, status) {
            commit('SET_OPCITY', status)
        },
    }
};

export default common;



// WEBPACK FOOTER //
// ./src/store/modules/common.js